import { render, staticRenderFns } from "./LogJiuzhengPl.vue?vue&type=template&id=216a4172&scoped=true"
import script from "./LogJiuzhengPl.vue?vue&type=script&lang=js"
export * from "./LogJiuzhengPl.vue?vue&type=script&lang=js"
import style0 from "./LogJiuzhengPl.vue?vue&type=style&index=0&id=216a4172&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a4172",
  null
  
)

export default component.exports